import React, { FunctionComponent } from 'react';

import { graphql } from 'gatsby';

import { UserJourney as UserJourneyType } from '@gojob/cms';
import Flex from '@gojob/ui-bits/Flex';
import Text from '@gojob/ui-bits/Text';

import BreakpointContainer from '../../BreakpointContainer';
import Buttons from '../../Buttons';
import Image from '../../Section/UserJourney/Image';
import Step from './Step';

export const UserJourneyFragment = graphql`
  fragment UserJourneyFragment on SanityUserJourney {
    title {
      title
      level
    }
    variant {
      variant
    }
    image {
      alt
      asset {
        localFile {
          childImageSharp {
            gatsbyImageData(width: 920, placeholder: BLURRED)
          }
        }
      }
    }
    steps {
      title {
        title
        level
      }
      text
      withStoreButtons: with_store_buttons
    }
    ctas {
      ...CtaFragment
    }
  }
`;

const UserJourney: FunctionComponent<UserJourneyType> = (props) => {
  const { ctas = [], image, steps = [] } = props;
  const { title, level = 'h2' } = props.title || {};

  const gatsbyImageData = image.asset.localFile.childImageSharp?.gatsbyImageData;
  const alt = image?.alt || '';

  return (
    <BreakpointContainer
      css={{ overflow: 'hidden' }}
      alignItems="center"
      maxWidth="xl"
      padding={{ xs: [8, 2], md: 8 }}
    >
      {title && (
        <Text variant="headline1" as={level} css={{ textAlign: 'center' }}>
          {title}
        </Text>
      )}
      <Flex flexDirection="row" width="100%" margin={[10, 0]} justifyContent="center">
        {gatsbyImageData && <Image alt={alt} image={gatsbyImageData} />}

        <BreakpointContainer flexDirection="column" flex="1 0 55%" margin={[-2, 0]} maxWidth="lg">
          {steps.map((step, i) => (
            <Step {...step} index={i + 1} margin={{ xs: [1, 0], md: [2, 0] }} key={i} />
          ))}
        </BreakpointContainer>
      </Flex>
      {ctas.length > 0 && <Buttons ctas={ctas} />}
    </BreakpointContainer>
  );
};

export default UserJourney;
